import firebase from 'firebase/compat/app';
import env from 'env/.public-env.json';

const sampleCommitmentsFileURL = `gs://${env.PROJECT_ID}.appspot.com/samples/customer_commitments_sample.csv`;

const getSampleFile = (): Promise<string> =>
  firebase.storage().refFromURL(sampleCommitmentsFileURL).getDownloadURL();

export default getSampleFile;
